<template>
  <div class="custom-actions">
    <a
      class="button is-white has-text-weight-bold"
      @click="itemAction(rowData.uuid)"
    >Details</a>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction(uuid) {
      window.location.href = `/tenant/view/${uuid}`;
    }
  }
};
</script>

<style scoped>
    a.button.is-white {
        color: rgba(var(--primary-blue),1);
    }
</style>
